import React from 'react';

// §4 面部 — 下巴 (chin-color). Bridge/nose/face/lip colors render inside the muzzle-style groups (FaceDetailSection).
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function FaceSection({ config, parts }) {
  return (
    <>
<path className={"hood-" + config['chin-color'] + " str_332C2B_20"} d={parts['chin-color_c'] || ''}/>
    </>
  );
}
